import angular from "angular";
import { BuilderViewConfig as CommonConfig } from "./BuilderViewConfigInfo";

//customize ordinary BuilderView配置
let localConfig = {

}

//开发环境配置
if (ENV_IS_DEV_MODE) {
    localConfig = {
        PC_BROWSER: {
            opera: 1,
            ie: 1,
            edge: 1,
            edg: 1,
            safari: 1,
            firefox: 1,
            chrome: 1
        },
        MOBILE_BROWSER: {
            chrome: 1,
            safari: 1,
            firefox: 1,
            opera: 1,
            uc: 1,
            qq: 1,
            baidu: 1,
            wechat: 1
        }
    }
}

//测试环境配置
if (ENV_IS_TEST_MODE) {
    localConfig = {
        PC_BROWSER: {
            opera: 35,
            ie: 11,
            edge: 17,
            edg: 17,
            safari: 14,
            firefox: 43,
            chrome: 33
        },
        MOBILE_BROWSER: {
            chrome: 78,
            safari: 14,
            firefox: 98,
            opera: 12,
            uc: 13,
            qq: 10.9,
            baidu: 13.1,
            wechat: 8.0
        }
    }
}

//生产环境配置
if (ENV_IS_PROD_MODE) {
    localConfig = {
        PC_BROWSER: {
            opera: 35,
            ie: 11,
            edge: 17,
            egd: 17,
            safari: 14,
            firefox: 43,
            chrome: 33
        },
        MOBILE_BROWSER: {
            chrome: 78,
            safari: 14,
            firefox: 98,
            opera: 12,
            uc: 13,
            qq: 10.9,
            baidu: 13.1,
            wechat: 8.0
        }
    }
}

//合并通用配置和ordinary BuilderView通用配置
export const BuilderViewConfig = angular.merge(CommonConfig, localConfig) as (typeof CommonConfig & typeof localConfig);